import React, { Component } from 'react'
import { Dropdown } from 'primereact/dropdown'
import { getTps } from '../../services/localstorage/localstorage.service'

export default class OperadoresLogisticosDropdown extends Component {
  state = { tps: [] }

  componentDidMount = () => {
    const tps = this._parseItems(getTps(false))
    this.setState({ tps })
  }
  render() {
    const { tps } = this.state
    return tps.length === 0 ? null : (
      <Dropdown
        style={{ width: '100%' }}
        value={this.props.value}
        options={tps}
        onChange={e => this.props.onChange(e.value)}
        placeholder="Operador Logístico"
      />
    )
  }
  _parseItems(tps) {
    return tps.map(tp => {
      return {
        label: tp.name,
        value: tp.id,
      }
    })
  }
}
